/** @jsxRuntime classic */
/** @jsx jsxCustomEvent */
import jsxCustomEvent from '@micro-zoe/micro-app/polyfill/jsx-custom-event'

import React from 'react'
import * as microConfig from '@/views/micro/config'
import useStore from '@/store/persistStore'
import { useNavigate } from 'react-router-dom'
import config from '@/config'
import { cryptoPassword, tree2Array } from '@/utils'
import useGlobalThemeStore from '@/store/globalTheme'
import { apiLogin } from '@/api/common'
import useMicroConfig from '@/hooks/useMicroConfig'

interface LoginInfo {
  token: string
  username?: string
  name?: string
  [key: string]: any
}

const Login: React.FC = () => {
  const navigate = useNavigate()
  const { setState } = useStore
  const { theme } = useGlobalThemeStore()
  const { microUrl } = useMicroConfig()
  const getLoginInfo = (info: LoginInfo) => {
    setState({
      token: info.token,
      loginInfo: info,
      permissionCodes: tree2Array(info.privileges, 'childrenPrivileges').map(
        (item: any) => item.code
      ),
    })
    if (info?.token) {
      setTimeout(() => {
        navigate('/')
      }, 500)
    }
  }

  const handleLogin = async (values: any) => {
    const response: any = await apiLogin({
      ...values,
      password: cryptoPassword(values.password || '')
    })
    const { token, privileges } = response
    localStorage.setItem('token', token)
    localStorage.setItem(
      'permissionCodes',
      tree2Array(privileges, 'childrenPrivileges')
        .map((item) => item.code)
        .join(',')
    )
    getLoginInfo(response)
  }
  return (
    <div>
      {microUrl && (
        <micro-app
          iframe
          name={microConfig.MICRO_APPS[0].name}
          url={microUrl}
          defaultPage={microConfig.BASE_ROUTE.login}
          data={{
            title: 'iKG',
            version: config.version,
            theme,
            loginThirdParty: handleLogin
          }}
        />
      )}
    </div>
  )
}

export default Login

export const Agreement: React.FC = () => {
  const { theme } = useGlobalThemeStore()
  const { microUrl } = useMicroConfig()
  return (
    <div>
      {microUrl && (
        <micro-app
          name={microConfig.MICRO_APPS[0].name}
          url={microUrl}
          defaultPage={microConfig.BASE_ROUTE.agreement}
          data={{
            theme
          }}
        />
      )}
    </div>
  )
}

export const PrivacyPolicy: React.FC = () => {
  const { theme } = useGlobalThemeStore()
  const { microUrl } = useMicroConfig()
  return (
    <div>
      {microUrl && (
        <micro-app
          name={microConfig.MICRO_APPS[0].name}
          url={microUrl}
          defaultPage={microConfig.BASE_ROUTE.privacyPolicy}
          data={{
            theme
          }}
        />
      )}
    </div>
  )
}
